/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ContentApi extends runtime.BaseAPI {
    /**
     * Get Changelog By Version
     */
    async v2GetChangelogByVersionRaw(requestParameters, initOverrides) {
        if (requestParameters['lang'] == null) {
            throw new runtime.RequiredError('lang', 'Required parameter "lang" was null or undefined when calling v2GetChangelogByVersion().');
        }
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError('version', 'Required parameter "version" was null or undefined when calling v2GetChangelogByVersion().');
        }
        const queryParameters = {};
        const headerParameters = {};
        let urlPath = `/api/v2/content/{lang}/changelog/{version}`;
        urlPath = urlPath.replace(`{${"lang"}}`, encodeURIComponent(String(requestParameters['lang'])));
        urlPath = urlPath.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get Changelog By Version
     */
    async v2GetChangelogByVersion(requestParameters, initOverrides) {
        const response = await this.v2GetChangelogByVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Latest Changelog
     */
    async v2GetLatestChangelogRaw(requestParameters, initOverrides) {
        if (requestParameters['lang'] == null) {
            throw new runtime.RequiredError('lang', 'Required parameter "lang" was null or undefined when calling v2GetLatestChangelog().');
        }
        const queryParameters = {};
        const headerParameters = {};
        let urlPath = `/api/v2/content/{lang}/changelog/latest`;
        urlPath = urlPath.replace(`{${"lang"}}`, encodeURIComponent(String(requestParameters['lang'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get Latest Changelog
     */
    async v2GetLatestChangelog(requestParameters, initOverrides) {
        const response = await this.v2GetLatestChangelogRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Latest Changelog Version
     */
    async v2GetLatestChangelogVersionRaw(requestParameters, initOverrides) {
        if (requestParameters['lang'] == null) {
            throw new runtime.RequiredError('lang', 'Required parameter "lang" was null or undefined when calling v2GetLatestChangelogVersion().');
        }
        const queryParameters = {};
        const headerParameters = {};
        let urlPath = `/api/v2/content/{lang}/changelog/latestversion`;
        urlPath = urlPath.replace(`{${"lang"}}`, encodeURIComponent(String(requestParameters['lang'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get Latest Changelog Version
     */
    async v2GetLatestChangelogVersion(requestParameters, initOverrides) {
        const response = await this.v2GetLatestChangelogVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Render Pdf
     */
    async v2RenderPdfRaw(requestParameters, initOverrides) {
        if (requestParameters['htmlPdfRenderRequest'] == null) {
            throw new runtime.RequiredError('htmlPdfRenderRequest', 'Required parameter "htmlPdfRenderRequest" was null or undefined when calling v2RenderPdf().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        let urlPath = `/api/v2/content/render-pdf`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['htmlPdfRenderRequest'],
        }, initOverrides);
        return new runtime.BlobApiResponse(response);
    }
    /**
     * Render Pdf
     */
    async v2RenderPdf(requestParameters, initOverrides) {
        const response = await this.v2RenderPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
